var _dec, _dec2, _class;
import { "BeanInfo" as __z_BeanInfo } from "zova";
// eslint-disable
/** interceptor: begin */
export * from '../bean/interceptor.body.js';
export * from '../bean/interceptor.headers.js';
export * from '../bean/interceptor.jwt.js';
export * from '../bean/interceptor.mock.js';
export * from '../bean/interceptor.performAction.js';
import 'zova-module-a-fetch';
/** interceptor: end */
/** interceptor: begin */
import { InterceptorBody } from '../bean/interceptor.body.js';
import { InterceptorHeaders } from '../bean/interceptor.headers.js';
import { InterceptorJwt } from '../bean/interceptor.jwt.js';
import { InterceptorMock } from '../bean/interceptor.mock.js';
import { InterceptorPerformAction } from '../bean/interceptor.performAction.js';
import 'zova';
/** interceptor: end */
/** config: begin */
export * from '../config/config.js';
/** config: end */
/** scope: begin */
import { BeanScopeBase } from 'zova';
import { Scope } from 'zova-module-a-bean';
export let ScopeModuleAInterceptor = (_dec = Scope(), _dec2 = __z_BeanInfo({
  module: "a-interceptor"
}), _dec(_class = _dec2(_class = class ScopeModuleAInterceptor extends BeanScopeBase {}) || _class) || _class);
import 'zova';

/** scope: end */